import { Text } from '@wix/design-system';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import s from './RevShareSubtitle.scss';
import { RootStore, withInjectedRootStore } from '../../../providers';
import { CyclesController } from '../../../pages/SubscriptionPage/Cycles/Cycles.controller';
import { calculateRevShareSubtitleAmount, getRevShareSubtitleKey } from '../../../utils/utils';
import { InjectedExperimentsProps, withExperiments } from '@wix/wix-experiments-react';
import { observer } from 'mobx-react';

export interface RevShareSubtitleProps extends InjectedExperimentsProps {
    rootStore: RootStore;
}

export const RevShareSubtitleComp = ({ rootStore, experiments }: RevShareSubtitleProps) => {
    const { currentCycle, currentProduct, revShareData, currentStep, appContext } = rootStore.appStore;
    const { biLogger, siteGuid: msid } = appContext;
    const controller = React.useMemo(
        () => new CyclesController({ rootStore, experiments }),
        [currentCycle, currentProduct],
    );

    const { cycles } = controller;
    const cyclesDetails = cycles.map(cycle => cycle.cycleDetails);

    useEffect(() => {
        biLogger.logIsRevShareVisible({ msid });
    }, [msid, biLogger]);

    const revShareEarnedAmount = React.useMemo(() => {
        return calculateRevShareSubtitleAmount({
            currentStep,
            cycles: cyclesDetails,
            currentCycle,
            revShareData,
            productGuid: currentProduct.guid
        });
    }, [currentStep, cycles, currentCycle, revShareData, currentProduct.guid]);

    const subtitleKey = getRevShareSubtitleKey(currentStep, revShareEarnedAmount);
    return (
        <Text size="medium" weight="normal" dataHook="rev-share-subtitle">
            <PremiumCurrencyFormatter
                currencySettingsOverride={{ fractionSize: 2 }}
                render={(formatCurrency) => {
                    return (
                        <Trans
                            i18nKey={subtitleKey}
                            components={{
                                strong: <Text weight="bold" className={s.revShareSubtitle} />
                            }}
                            values={{
                                amountEarned: formatCurrency(revShareEarnedAmount),
                            }}
                        />
                    )
                }}
            />
        </Text>
    )
};

export const RevShareSubtitle = withInjectedRootStore(withExperiments(observer(RevShareSubtitleComp)));